<template>
  <div class="report-wrap">
    <div class="header">
      <div class="page-header">留存报告</div>
      <div style="display: flex">
        <div style="flex: 1">
          <el-select class="select-item" v-model="filterData.pkg" placeholder="选择产品" filterable>
            <el-option
              v-for="item of appList"
              :key="item.package_name"
              :label="item.app_name + '（' + item.package_name + '）'"
              :value="item.package_name"
            >
            </el-option>
          </el-select>
          <el-select
            @change="changePlatType"
            class="select-item"
            v-model="filterData.platType"
            placeholder="选择媒体渠道"
            filterable
          >
            <el-option label="全部渠道" :value="null"> </el-option>
            <el-option label="今日头条" :value="1"> </el-option>
            <el-option label="广点通" :value="2"> </el-option>
            <el-option label="快手" :value="3"> </el-option>
          </el-select>
          <el-select
            @change="changeCampaignId"
            class="select-item"
            filterable
            v-model="filterData.campaignId"
            placeholder="全部广告组"
          >
            <el-option label="全部广告组" :value="null"></el-option>
            <el-option
              v-for="item of campaignIdList"
              :key="item.campaignId"
              :label="item.campaignName + ' (' + item.campaignId + ')'"
              :value="item.campaignId"
            >
            </el-option>
          </el-select>
          <el-select
            class="select-item"
            v-model="filterData.adSetId"
            placeholder="全部广告计划"
            filterable
          >
            <el-option label="全部广告计划" :value="null"></el-option>
            <el-option
              v-for="item of adSetList"
              :key="item.adGroupId"
              :label="item.adGroupName"
              :value="item.adGroupId"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <el-button style="margin-left: 16px" @click="resetSearch">重置</el-button>
          <el-button type="primary" @click="clickSearch">查询</el-button>
        </div>
      </div>
      <div style="display: flex; margin-top: 16px">
        <div style="flex: 1">
          日期范围选定：
          <el-date-picker
            style="width: 300px"
            v-model="filterData.time"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyyMMdd"
            :clearable="false"
          >
          </el-date-picker>
        </div>
        <div style="display: flex">
          <el-button style="margin-left: 16px" type="primary" @click="exportExcel">导出</el-button>
        </div>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" ref="table" style="width: 100%" @sort-change="sortChange">
        <el-table-column
          v-for="item of columns"
          :key="item.value"
          :prop="item.value"
          :label="item.label"
          min-width="120"
          :width="item.width"
          :sortable="item.sort"
        >
          <template slot-scope="scope">
            <div
              v-if="
                [
                  'retention1',
                  'retention2',
                  'retention3',
                  'retention4',
                  'retention5',
                  'retention6',
                  'retention7',
                ].includes(item.value)
              "
            >
              <div>{{ scope.row[`${item.value}Rate`] }}%</div>
              <div>{{ scope.row[item.value] }}</div>
            </div>
            <div v-else-if="item.value === 'statDate'">
              <div>{{ scope.row[item.value] }}</div>
              <div>{{ scope.row.active }}</div>
            </div>
            <div v-else>{{ scope.row[item.value] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <self-pagination
      class="table-pagination"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      @getCurrentPage="changePage"
      @handleSizeChange="changePageSize"
      ref="tabelPagination"
    ></self-pagination>
  </div>
</template>

<script>
import { getCommonProductList } from "@/api/api.js";
import { getCampaignList, getAdGroupList } from "@/api/promotionReport.js";
import { getRetentionData } from "@/api/tools";
import moment from "moment";
import { downLoadWrokSheet } from "@/utils/commonTools";
export default {
  data() {
    return {
      appList: [],
      adSetList: [],
      campaignIdList: [],
      orderBy: null,
      filterData: {
        pkg: null,
        platType: null,
        adSetId: null,
        campaignId: null,
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableData: [],
      tableCols: [],
      columns: [
        { label: "媒体渠道", value: "platTypeStr" },
        { label: "激活日期", value: "statDate", sort: true },
        { label: "广告计划", value: "ad_name", width: "350px" },
        { label: "广告组", value: "campaign_name" },
        { label: "Day 1", value: "retention1" },
        { label: "Day 2", value: "retention2" },
        { label: "Day 3", value: "retention3" },
        { label: "Day 4", value: "retention4" },
        { label: "Day 5", value: "retention5" },
        { label: "Day 6", value: "retention6" },
        { label: "Day 7", value: "retention7" },
        { label: "Day 14", value: "retention14" },
        { label: "Day 30", value: "retention30" },
      ],
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.initSelectOptions();
  },

  methods: {
    initSelectOptions() {
      //产品
      getCommonProductList().then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
          this.filterData.pkg = this.appList[0]?.package_name;
          this.getCampaignOptions();
          this.getAdOptions();
          this.getList();
        }
      });
    },
    getCampaignOptions() {
      getCampaignList(
        this.filterData.platType ? { platType: this.filterData.platType } : null
      ).then((res) => {
        if (res.code === "0000") {
          this.campaignIdList = res.data;
        }
      });
    },
    changePlatType() {
      this.filterData.campaignId = null;
      this.filterData.adSetId = null;
      this.getCampaignOptions();
    },
    changeCampaignId() {
      this.filterData.adSetId = null;
      this.getAdOptions();
    },
    sortChange({ order }) {
      if (order) {
        this.orderBy = order === "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = null;
      }
      this.getList();
    },

    getAdOptions() {
      getAdGroupList(
        this.filterData.campaignId ? { campaignId: this.filterData.campaignId } : null
      ).then((res) => {
        if (res.code === "0000") {
          this.adSetList = res.data;
        }
      });
    },
    getList() {
      const { pkg, platType, adSetId, campaignId, time } = this.filterData;
      getRetentionData({
        pkg,
        platType,
        adSetId,
        campaignId,
        campaignName: this.campaignIdList.find((item) => item.campaignId === campaignId)
          ?.campaignName,
        dateStart: time[0],
        dateEnd: time[1],
        orderBy: this.orderBy,
      }).then((res) => {
        this.tableData = res.data;
        this.tableData.total = res.data.length;
      });
    },
    resetSearch() {
      this.filterData = {
        pkg: null,
        platType: null,
        adSetId: null,
        campaignId: null,
        time: [
          moment().subtract(7, "days").format("YYYYMMDD"),
          moment().subtract(1, "days").format("YYYYMMDD"),
        ],
      };
      this.orderBy = null;
      this.$refs.table.clearSort();
      this.clickSearch();
    },
    clickSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    exportExcel() {
      const data = JSON.parse(JSON.stringify(this.tableData));
      const haderData = {};
      const columns = this.columns;
      columns.forEach((item) => {
        haderData[item.value] = item.label;
      });
      downLoadWrokSheet(data, "留存报告.xlsx", haderData);
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.report-wrap {
  padding: 16px 16px 0 16px;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  .header {
    align-items: center;
    padding: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    margin-bottom: 16px;
    .page-header {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
      margin-bottom: 12px;
    }
    .select-item {
      width: 240px;
      margin-right: 16px;
    }
  }
  .content {
    height: calc(100% - 210px);
    overflow: auto;
    padding: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  }
}
</style>
